import { render, staticRenderFns } from "./ArticleOpenGraphPersonalizacao.vue?vue&type=template&id=45016e20&"
import script from "./ArticleOpenGraphPersonalizacao.vue?vue&type=script&lang=js&"
export * from "./ArticleOpenGraphPersonalizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports